import { cn } from "@/lib/utils";

/**
 * 与 ClientRouter 主内容区一致：最大宽度 + 水平内边距。
 * 顶栏/底栏等 fixed 层内层使用，保证与正文对齐。
 */
export const appShellInnerClassName =
  "mx-auto w-full max-w-[1600px] px-3 sm:px-5 lg:px-8";

/** fixed 条内白底列（与主内容背景一致） */
export const appShellFixedColumnClassName = cn(
  appShellInnerClassName,
  "bg-background",
);
